import classnames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import './style.scss';

const InfoCard = (props) => {
  const renderItem = (item, key) => (
    <div key={key} className={classnames('flex-col', (!!key && key !== 0) ? 'mt-76' : '')}>
      <h3 className="info-card-title">{item.title}</h3>
      { _.map(item.data, (x, i) => (
        <div key={i} className={classnames('info-card-row', i !== 0 ? 'mt-12' : 'mt-10')}>
          <p className="info-card-row-label">{x.label}</p>
          {!_.isEmpty(x.link) ? (
            <a className="info-card-row-link" href={x.link}>{x.value}</a>
          ) : (
            <p className={classnames('info-card-row-value', x.label === 'Compatible brand:' || x.label === 'Compatible model:' ? 'upper-case' : '')}>{x.value}</p>
          )}
        </div>
      ))
      }
    </div>
  );

  const renderData = () => (
    _.map(props.data, (x, i) => (
      <>
        {renderItem(x, i)}
      </>
    ))
  );

  return (
    <div
      className={classnames('info-card', props.className)}
    >
      {renderData()}
    </div>
  );
};

InfoCard.defaultProps = {
  className: '',
  data: [],
};
InfoCard.propTypes = {
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      link: PropTypes.string,
    })),
  })),
};

export default InfoCard;
